import { render, staticRenderFns } from "./AdminTooltipsSearch.vue?vue&type=template&id=a3985868&"
import script from "./AdminTooltipsSearch.vue?vue&type=script&lang=js&"
export * from "./AdminTooltipsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports